module.exports = __webpack_public_path__ + "img/bg@3x.dfef9c4e.png";